import { gql } from '@apollo/client';

export const FILTERED_INSTITUTION_ECD_REGISTRATIONS = gql`
  query FilteredInstitutionEcdRegistrations($input: ECDRegistrationInput!) {
    ecdRegistrations: filteredInstitutionEcdRegistrations(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          approvalStatus
          certificateNumber
          lastDateModified
          newOrRenewal
          registrationType {
            id
            name
          }
          submitted
          associatedEcdInstitution {
            id
            validated
          }
        }
      }
    }
  }
`;
